
import React from 'react';
import Layout from '@/components/Layout';

const ResetPasswordPage: React.FC = () => {
  return (
    <Layout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Set New Password</h1>
        <p className="mt-4">Create a new password for your account.</p>
      </div>
    </Layout>
  );
};

export default ResetPasswordPage;
